import { useMutation } from '@apollo/client';
import { DOWNLOAD_URLMETA_VIDEO } from '../gql-operations/mutations/message/download-urlmeta-video';

function useDownloadUrlMetaVideo() {
    const [downloadUrlMetaVideoMutation, result] = useMutation(DOWNLOAD_URLMETA_VIDEO);

    const downloadVideo = async ({ messageId, urlMetaIndex, abortSignal }) => {
        const context = abortSignal
            ? {
                fetchOptions: {
                    signal: abortSignal
                }
            }
            : undefined;

        const res = await downloadUrlMetaVideoMutation({
            variables: {
                data: {
                    messageId,
                    urlMetaIndex
                }
            },
            context
        });
        return res?.data?.downloadUrlMetaVideo;
    };

    return {
        downloadVideo,
        ...result
    };
}

export default useDownloadUrlMetaVideo;
